import SearchLocation from './SearchLocation';

export default SearchLocation;
